

// 旧协议
function kkhybrid_play_ad_videos (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "play_ad_videos",
    },
    param: {
      ad_pos_id: opt.ad_pos_id,
      ad_type: opt.ad_type,
      context_id: opt.context_id
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}

// 新协议
function kkmhhybrid_play_ad_videos (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "play_ad_videos",
    },
    param: {
      ad_pos_id: opt.ad_pos_id,
      ad_type: opt.ad_type,
      context_id: opt.context_id
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    },
    on: true
  });
}

/**
 * 激励视频广告播放<br>
 * kkhybrid://play_ad_videos{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=139364251}<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.ad_pos_id 快看广告位
 * @param {String} opt.ad_type 广告类型（如激励视频）
 * @param {String} opt.context_id 业务方自定义id
 * @param {String} opt.extra 需要透传的参数
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function play_ad_videos (opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
  if(allow){
    kkmhhybrid_play_ad_videos(opt);
  } else {
    kkhybrid_play_ad_videos(opt)
  }
}

export default play_ad_videos;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/play_ad_videos/index.js